// Utility for permission checking
export function hasPermission(permissions, permissionId, isAdmin) {
  if (!Array.isArray(permissions)) return false;
  if (permissionId === 'Add New Organization' && !isAdmin) return false;
  return permissions.some(
    (permission) => permission.permissionId === permissionId || permission.permissionId === "*"
  );
} 